import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "antd";
import { useI18n } from "../../../../../contexts/i18n.js";
import { useUpsell } from "../../../../../contexts/upsell.js";
const FormContentBlockerFieldVisualMediaThumbnail = ({ children })=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    return isPro && /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.visualDownloadThumbnail !== nextValues.visualDownloadThumbnail || prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType || prevValues.visualContentType !== nextValues.visualContentType,
        children: ({ getFieldValue })=>{
            const isVisual = getFieldValue("isVisual");
            const visualType = getFieldValue("visualType");
            const visualContentType = getFieldValue("visualContentType");
            const visualDownloadThumbnail = getFieldValue("visualDownloadThumbnail");
            return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsx(Form.Item, {
                label: visualDownloadThumbnail || visualContentType === "generic" ? __("Fallback preview image") : __("Preview image"),
                name: "visualMediaThumbnail",
                valuePropName: "attachmentId",
                style: {
                    display: visualDownloadThumbnail === undefined ? "none" : undefined
                },
                children: children
            });
        }
    });
};
export { FormContentBlockerFieldVisualMediaThumbnail };
